export default __webpack_public_path__ + "static/media/ethereum-logo.79f94474.png";